var _circle, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "38.771 40.433 292.87 292.87",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.206,
    cy: 186.868,
    fill: "none",
    r: 141.935,
    stroke: "#6f6e6f",
    strokeWidth: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m98.422 186.879c0-47.933 38.855-86.787 86.789-86.789 47.931.002 86.784 38.855 86.786 86.789-.002 47.931-38.855 86.784-86.786 86.787-47.934-.003-86.789-38.856-86.789-86.787zm28.883-57.904c-14.823 14.827-23.982 35.283-23.984 57.904.002 22.62 9.161 43.077 23.984 57.903 14.827 14.821 35.283 23.982 57.906 23.984 22.618-.002 43.074-9.163 57.901-23.984 14.822-14.826 23.982-35.283 23.984-57.903-.002-22.621-9.162-43.077-23.984-57.904-14.827-14.823-35.283-23.982-57.901-23.984-22.623.002-43.079 9.161-57.906 23.984z",
    fill: "#6f6e6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m98.458 186.874h86.795v-86.784h-.006c-47.932.002-86.786 38.853-86.789 86.784z",
    fill: "#0066ad"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m271.979 186.83h-86.795v86.841h.006c47.931-.002 86.786-38.91 86.789-86.841z",
    fill: "#0066ad"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m285.774 106.62-19.341 12.795 9.152-17.801c-2.379-2.811-5.981-5.766-5.981-5.766l-17.656 8.865 12.956-18.997c-2.151-1.806-4.64-3.308-7.027-5.119l-18.134 28.285s3.434 2.02 7.636 5.9l18.767-9.708-9.83 18.471c2.211 2.335 4.179 5.164 6.227 7.689l28.564-17.667c-.001 0-1.749-2.748-5.333-6.947zm-98.555-19.286 8.703-19.231.787 24.38c3.505.156 8.676 1.475 8.676 1.475l-1.562-34.531c-6.563-.954-11.8-1.215-11.8-1.215l-8.385 20.859-8.188-20.691s-5.408.527-11.972 1.48l-1.571 34.797s5.181-1.499 8.686-1.654l.74-24.753 8.725 19.083h7.161zm-73.657 11.306.001-.035a8.708 8.708 0 0 0 -2.553-8.739c-3.531-3.221-8.791-3.33-14.404 2.272 0 0-10.346 10.374-17.355 20.534l25.171 22.955 18.97-21.267c4.127-4.559 4.288-11.016.513-14.461-2.823-2.57-6.915-2.935-10.343-1.259zm-24.28 12.338c8.917-11.046 12.487-14.065 12.487-14.065 2.338-2.023 4.067-2.2 5.47-.921 1.404 1.278 1.227 3.764-.393 5.55l-12.603 13.958zm28.336-.928-13.236 14.695-4.975-4.536 13.237-14.694c1.618-1.787 4.046-2.223 5.42-.97s1.173 3.719-.446 5.505z",
    fill: "#6f6e6f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185.067,
    cy: 186.749,
    r: 128.722
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.365,
    cy: 186.749,
    r: 94.974
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f91ce28ebfbec92548ea4b9b63ffb31f.svg";
export { ForwardRef as ReactComponent };